/**
 * Stepping Stones goes wherever Word To Image goes (Spencer's call, 2026-11-02).
 * Each unit's row in KZ_GameFilterDataNew says which games it offers, at which
 * starting level. Doing this here instead of in that data keeps it true for
 * every community: Fort Belknap's rows are only in Firestore, a sheet re-import
 * replaces what's in NACA-Core, and a slow NACA-Core falls back to Firestore.
 *
 * A row that sets its own "Verb Activity" level keeps it (Red Lake's verb
 * units). A unit with neither gets an explicit null: a missing value would
 * read as "offered" to buildScoreData.
 */
const isOff = (value) => value === null || value === undefined || value === "" || value === "null";

export const addSteppingStones = (rows) =>
  rows.map((row) => {
    if (!isOff(row["Verb Activity"])) return row;
    const level = row["Word To Image"];
    return { ...row, "Verb Activity": isOff(level) ? null : level };
  });
